// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__22Mn3","colMin":"styles_colMin__3WGvU"};